export const FormSubtitle = ({ message }) => {
    return <span className="settings-modal-configs-form-subtitle">{message}</span>
}
